import { render, staticRenderFns } from "./SvgLogout.vue?vue&type=template&id=a8d5835a&"
import script from "./SvgLogout.vue?vue&type=script&lang=js&"
export * from "./SvgLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports